/**
 * @generated SignedSource<<d71189f769209b2cc9d01ca3a1ede380>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReservationStatus = "CANCELLED" | "CHECKED_OUT" | "CONFIRMED" | "DRAFT" | "PICKED" | "REQUESTED" | "RETURNED" | "%future added value";
export type CancelMyReservationInput = {
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type ClientReservationPageCancelMutation$variables = {
  input: CancelMyReservationInput;
};
export type ClientReservationPageCancelMutation$data = {
  readonly cancelMyReservation: {
    readonly reservation: {
      readonly id: string;
      readonly status: ReservationStatus;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type ClientReservationPageCancelMutation = {
  response: ClientReservationPageCancelMutation$data;
  variables: ClientReservationPageCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CancelMyReservationPayload",
    "kind": "LinkedField",
    "name": "cancelMyReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientReservationPageCancelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientReservationPageCancelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9c5036c05332c7327f0327b73d04ba5b",
    "id": null,
    "metadata": {},
    "name": "ClientReservationPageCancelMutation",
    "operationKind": "mutation",
    "text": "mutation ClientReservationPageCancelMutation(\n  $input: CancelMyReservationInput!\n) {\n  cancelMyReservation(input: $input) {\n    reservation {\n      id\n      status\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64b310162053f7325d129de65b6a6f21";

export default node;
